<template lang="pug" src="./slider-testimonials.pug"></template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import Icon from 'components/icon/icon'
export default {
  props: ['props'],
  components: {
    Carousel,
    Slide,
    Icon
  },
  mounted () {
    setInterval(() => {
      let carousel = this.$refs['testimonial-carousel']
      let currentPage = carousel.currentPage
      let pageCount = carousel.pageCount
      currentPage < pageCount - 1 ? carousel.goToPage(currentPage + 1) : carousel.goToPage(0)
    }, 10000)
  },
  methods: {
    SlideCarousel (value) {
      const carousel = this.$refs['testimonial-carousel']
      const currentPage = carousel.currentPage
      const pageCount = carousel.pageCount
      if (value === 'prev') {
        currentPage !== 0 ? carousel.goToPage(currentPage - 1) : carousel.goToPage(pageCount - 1)
      } else {
        currentPage < pageCount - 1 ? carousel.goToPage(currentPage + 1) : carousel.goToPage(0)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// slider-testimonials.vue?7fe5de3c